/* eslint-disable no-unused-vars */
/**
 * 数字货币格式化
 * 注意：仅支持整数格式化
 * @param {number} num 整数数字
 */
import { cloneDeep, isArray, isEmpty } from 'lodash'
import random from 'string-random'
import { passwordRegularValid } from '@/utils/form-validate'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import Nzh from 'nzh'
import { encodeS } from 'nzh/cn'
import Decimal from 'decimal.js'

/**
 * 字符串货币格式化
 * @param {string} numStr 数字字符串，可带小数
 */
export function strToThousands(numStr) {
  if (numStr == null || numStr == undefined) return numStr
  return numStr.toString().replace(/\d+/, function(n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ','
    })
  })
}

/**
 * 对象数组去重
 * @param {Array} arr 对象数组
 * @param {string} key 用于识别重复的属性名，默认使用'id'
 */
export function unique(arr, key = 'id') {
  const res = new Map()
  return arr.filter(
    current => !res.has(current[key]) && res.set(current[key], 1)
  )
}

/**
 * 统计数组中的重复项数量
 * @param {Array} list 数组
 * @param {string} key 用于判断重复的关键字
 * @returns numObj 包含每项的重复数量和开始位置的对象
 */
export function countRepeatNum(list, key) {
  const tempIds = list.map(v => v[key])
  let tempIndex = 0
  const numObj = {}
  tempIds.forEach((idKey, index) => {
    if (numObj[idKey]) {
      numObj[idKey].num++
    } else {
      numObj[idKey] = {
        num: 1,
        start: index,
        index: ++tempIndex
      }
    }
  })

  return numObj
}

// 将账号按银行卡方式分隔，4个一组
export function bankCardFilter(cardNumber) {
  return cardNumber.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
}

/**
 * 处理浏览器地址，解析处query参数，返回一个包含query参数的对象
 * @param {String} url 浏览器地址
 */
export function getQueryFromURL(url) {
  const queryString = url.split('?')[1] || ''
  const queryStringArr = queryString.split('&') || []
  const queryObject = {}
  queryStringArr.forEach(value => {
    const temp = value.split('=')
    queryObject[temp[0]] = temp[1]
  })
  return queryObject
}

/**
 * 根据某个属性进行判断排序
 */
export function sortByKey(key) {
  return function(obj1, obj2) {
    if (Number(obj1[key]) < Number(obj2[key])) {
      return -1
    } else if (Number(obj1[key]) > Number(obj2[key])) {
      return 1
    } else {
      return 0
    }
  }
}

/**
 * 深度合并多个对象
 * @param {{}} opts 多个对象数据
 * @returns {{}} 合并后的新对象
 */
export const mergeObject = (...opts) => {
  const res = {}

  const combine = opt => {
    for (const prop in opt) {
      if (Object.prototype.toString.call(opt[prop]) === '[object Object]') {
        res[prop] = mergeObject(res[prop], opt[prop])
      } else {
        res[prop] = opt[prop]
      }
    }
  }

  for (let i = 0; i < opts.length; i++) {
    combine(opts[i])
  }

  return res
}

/**
 * 数字按位数补0
 * @param {number} num 数字
 * @param {number} n 位数
 * @returns {*}
 */
export function padNum(num, n = 2) {
  if ((num + '').length >= n) return num
  return padNum('0' + num, n)
}

/**
 * 将对象里的空转化成undefined
 */
export function changeEmptyToUndefined(obj) {
  const targetObj = {}
  // eslint-disable-next-line no-unused-vars
  for (const key in obj) {
    if (obj[key] !== '') {
      targetObj[key] = obj[key]
    } else {
      targetObj[key] = undefined
    }
  }
  return targetObj
}

/*
 * 下载投标文件制作客户端
 */
export function downloadAppTool() {
  const downloadUrl =
    process.env.VUE_APP_OSS_URL +
    '/bid-tool/' +
    '%E7%B2%BE%E5%BD%A9%E7%BA%B5%E6%A8%AA%E6%8A%95%E6%A0%87%E5%88%B6%E4%BD%9C%E5%B7%A5%E5%85%B7.zip'
  window.open(downloadUrl, '_self')
}

/**
 * 生成随机密码 (后期功能拓展：可以使用string-random库)
 * @param {Number} length 密码长度
 * @param {String} prefix 密码前缀
 * @param {Object} options 配置项
 * @returns {string|*}
 */
export function generatePassword(
  length = 6,
  prefix = '',
  options = { numbers: true, letters: true }
) {
  const tempOptions = Object.assign(
    {},
    { numbers: true, letters: true },
    options
  )
  const defaultPassword = prefix + random(length - prefix.length, tempOptions)
  if (passwordRegularValid.pattern.test(defaultPassword)) {
    return defaultPassword
  } else {
    return generatePassword(length, prefix, tempOptions)
  }
}

/**
 * 平铺列表转换成树嵌套数据
 * @param {*} arr 列表
 * @param {*} nodeKey 唯一标识字段名
 * @param {*} parentKey 父级标识字段名
 */
export function listTransformTree(arr, nodeKey = 'id', parentKey = 'parentId') {
  const temp = {}
  const tree = {}
  arr = cloneDeep(arr)

  // 数组转键值对
  arr.forEach(item => {
    temp[item[nodeKey]] = item
  })

  const tempKeys = Object.keys(temp)
  tempKeys.forEach(key => {
    // 当前项
    const item = temp[key]
    // 当前项pId
    const itemPId = item[parentKey]
    // 父级项
    const parentItemByPid = temp[itemPId]
    if (parentItemByPid) {
      if (!parentItemByPid.children) {
        parentItemByPid.children = []
      }
      parentItemByPid.children.push(item)
    } else {
      tree[item[nodeKey]] = item
    }
  })

  // 对象转数组并返回
  return Object.keys(tree).map(key => tree[key])
}

/**
 * 解析字符串实现对象属性路径访问
 * @param {Object} obj 要访问的对象
 * @param {String} path 属性路径字符串
 * @returns {null|*} 对应的属性值
 */
export function getPropByPath(obj, path) {
  let tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')

  const keyArr = path.split('.')
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj) break
    const key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
      // break;
    }
  }
  return tempObj ? tempObj[keyArr[i]] : null
}

/**
 * 前往标前狗相应页面
 */
export function toBiddogPage(routePath) {
  const url = process.env.VUE_APP_BIDDOG_URL + routePath
  window.open(url, '_target')
}

/**
 * 跳转至云采购门户公告页
 */
export function toPortalNotice({ noticeId = '', noticeUrl = '' }) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = noticeId
    ? process.env.VUE_APP_PORTAL_URL + '/notice/' + noticeId
    : noticeUrl
  window.open(url, '_blank')
}

/**
 * 计算时间与当前时间时间差
 * @param {string} date 日期
 */
export function diffTime(date) {
  const difference = dayjs().diff(dayjs(date), 'minutes')
  let text = ''
  if (difference < 60) {
    text = `${difference}分钟前`
  } else if (difference >= 60 && difference < 60 * 24) {
    text = `${Math.floor(difference / 60)}小时前`
  } else if (difference >= 60 * 24 && difference < 60 * 24 * 7) {
    text = `${Math.floor(difference / 60 / 24)}天前`
  } else {
    text = date
  }
  return text
}

/**
 * 计算当前时间要展示的文案
 *
 */
export function getTimeText() {
  const timeNow = new Date()
  const hours = timeNow.getHours()
  let text = ``
  if (hours >= 0 && hours <= 10) {
    text = `早上好`
  } else if (hours > 10 && hours <= 14) {
    text = `中午好`
  } else if (hours > 14 && hours <= 18) {
    text = `下午好`
  } else if (hours > 18 && hours <= 24) {
    text = `晚上好`
  }
  return text
}

/**
 * 根据报价轮次返回中文文案
 */
export function roundNumHandle(num) {
  if (!num) return ''
  if (num == 1) {
    return '首次报价'
  } else {
    return `${encodeS(num)}次报价`
  }
}

/**
 * 过滤特殊字符
 *
 */
export function stripscript(s) {
  if (!s) return ''
  const pattern = new RegExp(
    "[`~!@#$^&*+()=|{}':;',\\[\\].<>/?%-~！@#￥……&*（）——|{}【】‘；：”“'。，、？↵\r\n]"
  )
  let rs = ''
  for (let i = 0; i < s.length; i++) {
    rs = rs + s.substr(i, 1).replace(pattern, '')
  }
  return rs
}

/**
 * 将query参数添加到url中 并 返回新的url，默认会携带上ac
 * @param oldUrl {String} 原url
 * @param queryObj {Object} 需要增加的query参数
 * @param needAC {Boolean} 是否需要自动携带ac
 * @return {String} 新url
 */
export function addQueryToUrl(oldUrl, queryObj = {}, needAC = true) {
  const ac = Cookies.get('X-JCZH-AC')
  queryObj = Object.assign(
    {},
    queryObj,
    needAC && ac ? { 'x-jczh-ac': ac } : {}
  )
  if (!oldUrl || isEmpty(queryObj)) return oldUrl

  const tempUrl = oldUrl.split('#')[0] || ''
  const hashUrl = oldUrl.split('#')[1] || ''
  const mainUrl = tempUrl.split('?')[0] || ''
  const queryUrl = tempUrl.split('?')[1] || ''

  let queryUrlObj = {}
  queryUrl.split('&').forEach(value => {
    if (!value) return

    const temp = value.split('=')
    queryUrlObj[temp[0]] = temp[1]
  })
  queryUrlObj = Object.assign({}, queryUrlObj, queryObj)

  const queryList = Object.keys(Object.assign({}, queryUrlObj, queryObj)).map(
    key => {
      return `${key}=${queryUrlObj[key]}`
    }
  )

  let newUrl = mainUrl
  if (queryList.length) {
    newUrl = `${newUrl}?${queryList.join('&')}`
  }
  if (hashUrl) newUrl = `${newUrl}#${hashUrl}`

  return newUrl
}

/**
 * 导出接口调用
 * @param {String} url 接口地址
 * @param {Object} params 接口参数
 * @param {String} baseURL 接口服务前缀
 */
export function exportRequest({
  url,
  params,
  baseURL = process.env.VUE_APP_PURCHASE_API
}) {
  window.open(addQueryToUrl(`${baseURL}${url}`, cloneDeep(params)))
}

/**
 * 浏览器全屏
 * @param {HTMLElement} [el=document] 全屏元素
 */
export function fullScreen(el) {
  el = el || document.documentElement
  const rfs =
    el.requestFullScreen ||
    el.webkitRequestFullScreen ||
    el.mozRequestFullScreen ||
    el.msRequestFullscreen
  if (typeof rfs !== 'undefined' && rfs) {
    rfs.call(el)
  }
}

/**
 * 退出全屏
 */
export function exitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

/**
 * 浏览器当前是否全屏
 * @return {*|boolean}
 */
export function isFullScreen() {
  return (
    document.isFullScreen ||
    document.mozIsFullScreen ||
    document.webkitIsFullScreen
  )
}

/**
 * 切换全屏
 */
export function fullToggle(ele, that, exitFullScreen, fullScreen) {
  if (that.isFullScreen) {
    exitFullScreen()
    that.isFullScreen = false
  } else {
    fullScreen(document.getElementById(ele))
    that.isFullScreen = true
  }
}

/**
 * 移动数组元素的位置
 */
export function moveInArray(array, from, to) {
  if (!isArray(array)) {
    throw new Error('请传入有效数组')
  }
  const item = array.splice(from, 1)
  if (!item.length) {
    throw new Error('没有找到需要移动的元素')
  }
  array.splice(to, 0, item[0])
  return array
}

/**
 * 数组转对象，key为指定数组元素中的某个属性
 * @param {Array} arr 数组
 * @param {String} keyName 对象的属性名
 * @param {String?} valueName 对象的值名称
 * @returns {{[p: string]: any}} 转换后的对象
 */
export function arrToObj(arr, keyName, valueName) {
  return Object.fromEntries(
    arr.map(item => [item[keyName], valueName ? item[valueName] : item])
  )
}

/**
 * 异步轮询
 */
export function asyncInterval(callback, interval = 3000) {
  let timer
  let isStop = false
  const stop = () => {
    console.log('停止')
    isStop = true
    clearTimeout(timer)
  }
  const start = async() => {
    isStop = false
    await loop()
  }
  const loop = async() => {
    try {
      await callback(stop)
    } catch (err) {
      console.error('轮询出错：', err)
      throw new Error('轮询出错：', err)
    }
    if (isStop) return
    return (timer = setTimeout(loop, interval))
  }
  return {
    start,
    stop
  }
}

/**
 * 获取金额中文大写
 * @param {String|Number} money 金额
 * @param {Number} multiple 金额倍数，100就是放大100倍
 * @returns {any|string}
 */
export function getMoneyInCn(money, multiple = 1) {
  const customNzh = new Nzh({
    ch: '零壹贰叁肆伍陆柒捌玖', // 数字字符
    ch_u: '个拾佰仟万亿兆京', // 数位单位字符，万以下十进制，万以上万进制，个位不能省略
    ch_f: '负', // 负字符
    ch_d: '点', // 小数点字符
    m_u: '元角分厘毫', // 金额单位
    m_t: '人民币', // 金额前缀
    m_z: '整'
  })
  // 去除千分位
  const moneyWithoutThousand = money?.toString()?.replace(/\,/g, '')
  // 将金额转换为数字
  const moneyNumber = Decimal.mul(parseFloat(moneyWithoutThousand), multiple)

  // 判断money转换后是否为数字
  if (isNaN(moneyNumber)) {
    return ''
  }

  return customNzh.toMoney(moneyNumber, { outSymbol: false })
}

/**
 * 字符串货币格式化
 * @param {string | Number} numStr 数字字符串，可带小数
 */
export function formatThousand(numStr) {
  if (numStr === null || numStr === undefined) return numStr
  return numStr.toString().replace(/\d+/, function(n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ','
    })
  })
}

/**
 * 将数值：大于万时，转成万；大于亿时，转成亿
 * @param {String | Number} num 传入的数值
 */
export function tranNumUnit(num) {
  if (num === '-' || num === null || num === undefined) {
    return '-'
  }

  num = Number(num)
  if (num >= 100000000) {
    return formatThousand(new Decimal(num).div(100000000).toFixed(2)) + '亿'
  } else if (num >= 10000) {
    return formatThousand(new Decimal(num).div(10000).toFixed(2)) + '万'
  } else {
    return formatThousand(num)
  }
}
